import axios from '@/utils/request';
const v1 = 'v1/profile';

export const getProfiles = ({ profile_id = null, profile_type = null }) => axios.get(`${v1}`, { params: { profile_id, profile_type } });

export const createProfile = (data) => axios.post(`${v1}`, data);
export const updateProfile = (id, data) => axios.put(`${v1}/${id}`, data);
export const deleteProfile = (id) => axios.delete(`${v1}/${id}`);
